import React, { useContext, useEffect, useRef, useState } from 'react';
import { Navigate } from 'react-router-dom';
import MyContext from './Context/AppContext'
import LoaderPage from './component/loaderPage/LoaderPage';



const ProtectedRoute = ({ component }) => {
  const hasRun = useRef(false)
  const { checkAuthStatus } = useContext(MyContext);
  const [isAuthenticated, setIsAuthenticated] = useState(null)

  const checkAuthenticationStatus = async () => {
    setIsAuthenticated(null)
    let response = await checkAuthStatus()
    setIsAuthenticated(response)
  }


  useEffect(() => {
    if (!hasRun.current) {
      hasRun.current = true
      checkAuthenticationStatus()
    }
  }, [])

  return (
    isAuthenticated === null ?
      <LoaderPage />
      :
      isAuthenticated ? component : <Navigate to="/" />
  )

}
export default ProtectedRoute;
